import Entity from './entity'

export default class Consumption extends Entity<string>{
    sourceId:string;
    sourceType:number;
}